<lib-back-arrow-button
  [label]="
    customLabel ||
    ((backToHome
      ? 'navigation-back-button.text.home-page'
      : 'navigation-back-button.text.back'
    ) | translate)
  "
  (clicked)="handleClick()"
></lib-back-arrow-button>
